import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  PurchaseState,
  PurchaseOrderPayload,
  ReceiveGoodsPayload,
} from "src/types/purchase.types";

const initialState: PurchaseState = {
  list: { loading: false, data: null, error: null },
  create: { loading: false, data: null, error: null },
  edit: { loading: false, data: null, error: null },
  receive: { loading: false, data: null, error: null },
};

const purchaseSlice = createSlice({
  name: "purchase",
  initialState,
  reducers: {
    // 📋 List Purchase Orders
    getPurchaseListRequest: (
      state,
      _action: PayloadAction<{
        page?: number;
        limit?: number;
        search?: string;
        orderStatus?: "pending" | "received" | "cancelled";
        supplierId?: string;
      }>
    ) => {
      state.list.loading = true;
      state.list.error = null;
    },
    getPurchaseListSuccess: (state, action: PayloadAction<any>) => {
      state.list.loading = false;
      state.list.data = action.payload;
    },
    getPurchaseListError: (state, action: PayloadAction<string>) => {
      state.list.loading = false;
      state.list.error = action.payload;
    },
    resetPurchaseList: (state) => {
      state.list = { loading: false, data: null, error: null };
    },

    // 🧾 Create Purchase Order
    createPurchaseRequest: (
      state,
      _action: PayloadAction<PurchaseOrderPayload>
    ) => {
      state.create.loading = true;
      state.create.error = null;
    },
    createPurchaseSuccess: (state, action: PayloadAction<any>) => {
      state.create.loading = false;
      state.create.data = action.payload;
    },
    createPurchaseError: (state, action: PayloadAction<string>) => {
      state.create.loading = false;
      state.create.error = action.payload;
    },
    resetCreatePurchase: (state) => {
      state.create = { loading: false, data: null, error: null };
    },

    // 🧾 Edit Purchase Order (pending only)
    editPurchaseRequest: (
      state,
      _action: PayloadAction<{ id: string; data: PurchaseOrderPayload }>
    ) => {
      state.edit.loading = true;
      state.edit.error = null;
    },
    editPurchaseSuccess: (state, action: PayloadAction<any>) => {
      state.edit.loading = false;
      state.edit.data = action.payload;
    },
    editPurchaseError: (state, action: PayloadAction<string>) => {
      state.edit.loading = false;
      state.edit.error = action.payload;
    },
    resetEditPurchase: (state) => {
      state.edit = { loading: false, data: null, error: null };
    },

    // 📦 Receive Goods (pending -> received, moves stock)
    receiveGoodsRequest: (
      state,
      _action: PayloadAction<ReceiveGoodsPayload>
    ) => {
      state.receive.loading = true;
      state.receive.error = null;
    },
    receiveGoodsSuccess: (state, action: PayloadAction<any>) => {
      state.receive.loading = false;
      state.receive.data = action.payload;
    },
    receiveGoodsError: (state, action: PayloadAction<string>) => {
      state.receive.loading = false;
      state.receive.error = action.payload;
    },
    resetReceiveGoods: (state) => {
      state.receive = { loading: false, data: null, error: null };
    },
  },
});

export const {
  getPurchaseListRequest,
  getPurchaseListSuccess,
  getPurchaseListError,
  resetPurchaseList,
  createPurchaseRequest,
  createPurchaseSuccess,
  createPurchaseError,
  resetCreatePurchase,
  editPurchaseRequest,
  editPurchaseSuccess,
  editPurchaseError,
  resetEditPurchase,
  receiveGoodsRequest,
  receiveGoodsSuccess,
  receiveGoodsError,
  resetReceiveGoods,
} = purchaseSlice.actions;

export default purchaseSlice.reducer;
